module.exports = __webpack_public_path__ + "img/icon_building_1.57b13576.png";